<template>
  <DialogContent :title="title" v-bind="$attrs">
    <template #trigger="{ open }">
      <slot name="trigger" :open="open" />
    </template>

    <div class="customer-dialog-content">
      <div class="group" v-for="(group, index) in groups" :key="index">
        <div class="title">
          {{ group.title }}
          <el-button v-if="group.list.length > 0" type="primary" size="mini" @click="exportList(group)">导出名单</el-button>
        </div>
        <div class="list">
          <template v-if="group.list.length === 0">
            /
          </template>
          <template v-else>
            <bean-link
              v-for="item in group.list"
              :key="item.id"
              target="_blank"
              keepNode
              :to="item.to || { name: 'customers.show', params: { id: item.id } }"
            >
              <el-tag size="mini" :type="group.type">{{ item.name }}</el-tag>
            </bean-link>
          </template>
        </div>
      </div>
    </div>

  </DialogContent>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import DialogContent from '@/components/dialog-content.vue';
import * as XLSX from 'xlsx';

@Component({
  components: {
    DialogContent,
  }
})
export default class CustomerDialog extends Vue {
  @Prop(String) title;
  @Prop(Array) groups;

  exportList(group) {
    const worksheet = XLSX.utils.aoa_to_sheet(group.list.map(item => [item.name]));
    worksheet['!cols'] = [{ wch: 20 }];
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
    XLSX.writeFile(workbook, `${this.title}-${group.title}.xlsx`);
  }
}
</script>

<style lang="scss">
.customer-dialog-content {
  .group {
    margin-bottom: 20px;
  }

  .title {
    font-size: 14px;
    color: #666;
    margin-bottom: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .list {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }
}
</style>
